import { render, staticRenderFns } from "./Pros.vue?vue&type=template&id=6d6d2d12&"
import script from "./Pros.vue?vue&type=script&lang=js&"
export * from "./Pros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports